/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export const getAutoComplete = (fieldName: string | undefined): string | undefined => {
    if (!fieldName) return undefined;

    const normalized = fieldName.toLowerCase().replace(/[-_]/g, "");

    // Map field names to autocomplete tokens
    if (/password/.test(normalized)) return "current-password";
    if (/^email/.test(normalized)) return "email";
    if (/firstname|givenname/.test(normalized)) return "given-name";
    if (/lastname|surname|familyname/.test(normalized)) return "family-name";
    if (/^phone|^tel|mobile/.test(normalized)) return "tel";
    if (/streetaddress|address/.test(normalized)) return "street-address";
    if (/postalcode|zipcode/.test(normalized)) return "postal-code";
    if (/^city/.test(normalized)) return "address-level2";
    if (/^url/.test(normalized)) return "url";
    if (/birthday|birthdate|bday|dob/.test(normalized)) return "bday";

    return undefined;
};
